export default {
	breakpointNames: ["xs", "sm", "md", "lg"], // don't touch the order of the entries, `isBreakpointOfSize` relies on it
	gridFloatBreakpoint: "sm",
	cssRulesPerSelector: {}, // Cache for below `detectCssRuleFor`

	normalizeContainerHeights: (
		containerSelectorOrEl,
		normalizeTargetsSelector,
		sizeSelector = ">xs",
	) => {
		// pp.log("VIEW HELPERS into normalizeContainerHeights", containerSelectorOrEl, normalizeTargetsSelector, sizeSelector);
		const $container =
			containerSelectorOrEl instanceof jQuery
				? containerSelectorOrEl
				: $(containerSelectorOrEl);
		// @ts-expect-error
		const $containerChildren = $container.children();
		const heights = [];
		const equalizeTargets = [];
		if ($containerChildren.length < 2) {
			return;
		}

		$containerChildren.each((idx, tabContent) => {
			const $compareElem =
				normalizeTargetsSelector !== undefined
					? $(tabContent).find(normalizeTargetsSelector)
					: $(tabContent);
			// pp.log("compare", $compareElem);
			// Reset before comparing to get the true height
			$compareElem.css("min-height", 0);
			if ($compareElem.outerHeight()) {
				heights.push($compareElem.outerHeight());
				equalizeTargets.push($compareElem);
			}
		});
		// Return here so we get the min-height reset
		if (!pp.viewHelpers.isBreakpointOfSize(sizeSelector)) {
			// pp.log("returning because outside of breakpoint scope");
			return;
		}

		const tallestHeight = heights.sort((a, b) => b - a)[0];
		// pp.log("tallestHeight: ", tallestHeight);

		$(equalizeTargets).each((idx, $target) => {
			$target.css("min-height", `${tallestHeight}px`);
		});
	},

	confirmTextPresent(customSelector) {
		const selector =
			customSelector ||
			"button[data-confirm-text-present-target-selector]:not(.completed)";
		// pp.log("VIEW HELPERS confirmTextPresent init -- selector:", selector);
		$(selector).each((index, elem) => {
			const $el = $(elem);
			const $target = $($el.data("confirmTextPresentTargetSelector"));
			$target.on("change keyup input", () => {
				// pp.log("change", $target.val());
				if ($target.val() === undefined || $target.val().trim().length == 0) {
					$el.attr("data-confirm", I18n.t("tasks.really_submit_with_no_text"));
				} else {
					$el.removeAttr("data-confirm");
				}
			});
			$target.trigger("change"); // eval once now
		});
	},

	stickKwitterForm() {
		$(window).off("scroll");
		const $formWrapper = $(".PublicationForm__wrapper");

		if (pp.viewHelpers.isBreakpointOfSize("<=sm")) {
			$formWrapper
				.find(".PublicationForm")
				.css({ boxShadow: "-1px -1px 3px rgba(0, 0, 0, 0.1)" });
		} else {
			pp.viewHelpers.fixElOnScroll($formWrapper);
			$formWrapper.find(".PublicationForm").css({ boxShadow: "none" });
		}
	},

	// unused
	// getStyle(el, styleProp) {
	// 	const x = !!el.nodeType ? el : document.getElementById(el);
	// 	if (x.currentStyle) {
	// 		return x.currentStyle[styleProp];
	// 	}
	// 	else if (window.getComputedStyle) {
	// 		return document.defaultView.getComputedStyle(x, null).getPropertyValue(styleProp);
	// 	}
	// },

	fixElOnScroll($el, desiredTop = 0) {
		//Get the bootstrap positioning
		$el.removeAttr("style");
		const elInitalOffset = $el.offset();
		const elInitalWidth = $el.outerWidth();

		const rightOffset =
			// @ts-expect-error
			$(document).width() - $el.offset().left - $el.outerWidth();

		$el.removeAttr("style");
		$(window).scroll(() => {
			// @ts-expect-error
			if ($(document).scrollTop() >= elInitalOffset.top) {
				$el.css({
					position: "fixed",
					top: desiredTop,
					width: elInitalWidth,
					right: rightOffset,
				});
			} else {
				$el.removeAttr("style");
			}
		});
	},

	closeModalOnBack($modal) {
		const closeModalWithBack = (event) => {
			$modal.modal("hide");
		};

		$modal.on("show.bs.modal", (e) => {
			if (history) {
				history.pushState(null, document.title, location.href);
				window.addEventListener("popstate", closeModalWithBack);
			}
		});

		$modal.on("hidden.bs.modal", (e) => {
			if (history) {
				window.removeEventListener("popstate", closeModalWithBack);
			}
		});
	},

	pausePlayingVideosOnAnyModalClose: {
		pauseVideosInModal: (event) => {
			const $videos = $(event.currentTarget).find("video");
			$videos.each((index, video) => {
				video.pause();
			});
		},

		init: () => {
			$(document).on(
				"hide.bs.modal",
				".modal.in",
				pp.viewHelpers.pausePlayingVideosOnAnyModalClose.pauseVideosInModal,
			);
		},
	},

	decorateHorizontallyScrollingEls: () => {
		// Detect horizontally scrolling els and add a style
		const $potentialScroller = $(".j-scroll-horizontal");
		if (
			!$potentialScroller.length ||
			// @ts-expect-error
			$potentialScroller.get(0).scrollWidth <= $potentialScroller.outerWidth()
		) {
			return;
		}

		if ($potentialScroller.parent().hasClass("Module__content__inline-menu")) {
			$potentialScroller.parent().addClass("HorizontalScrollActive");
		} else {
			$potentialScroller.addClass("HorizontalScrollActive");
		}
	},

	linkRtfInfoImages: () => {
		$(".rtf-content img").each((idx, img) => {
			if ($(img).parent("a").length) {
				return; // already wrapped
			}
			$(img).wrap(`<a href='${$(img).attr("src")}' target='_blank'></a>`);
		});
	},

	isBreakpointOfSize(sizeWithComparisionOperator) {
		// @ts-expect-error
		const currentIndex = this.breakpointNames.indexOf(pp.breakpointSize);
		let operator, breakpoint, compareToIndex;
		// Special case
		if (sizeWithComparisionOperator.indexOf("gridFloatBreakpoint") != -1) {
			operator =
				sizeWithComparisionOperator.replace("gridFloatBreakpoint", "") || "=="; // Strip out the operator or default to '=='
			breakpoint = this.gridFloatBreakpoint;
		} else if (sizeWithComparisionOperator.length > 2) {
			// luckily all the breakpoint names have a length of 2
			const slicedBreakpoint = sizeWithComparisionOperator.slice(-2);
			operator = sizeWithComparisionOperator.substring(
				0,
				sizeWithComparisionOperator.indexOf(slicedBreakpoint),
			);
			breakpoint = sizeWithComparisionOperator.replace(operator, "");
		} else {
			operator = "==";
			breakpoint = sizeWithComparisionOperator;
		}
		compareToIndex = this.breakpointNames.indexOf(breakpoint);
		//pp.log("operation", currentIndex, operator, compareToIndex);
		return eval(`${currentIndex} ${operator} ${compareToIndex}`);
	},

	detectViewportBreakpointChange: {
		init() {
			let resizeTimer;
			$(window).on("resize", (e) => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(
					pp.viewHelpers.detectViewportBreakpointChange.detectNow,
					150,
				);
			});

			$(document).on("page:change", () => {
				// should only be triggered after everything has been loaded but still wait a little while for the listeners to register
				setTimeout(() => {
					$(document).trigger("bootstrap:breakpoint-changed");
				}, 10);
			});

			$(document).on("page:before-change", () => {
				$(document).off("bootstrap:breakpoint-changed"); // assume that we don't need any of them listeners anymore
			});
			this.detectNow(); // detect once now
		},
		detectNow() {
			// Do this outside of the timeout
			const toSize = pp.viewHelpers.breakpointNames.find((size) => {
				return $(`#device-${size}`).is(":visible");
			});
			// @ts-expect-error
			if (pp.breakpointSize !== toSize) {
				pp.log(
					// @ts-expect-error
					`VIEW HELPERS viewport changed from: ${pp.breakpointSize} to: ${toSize}`,
				);
				// @ts-expect-error
				pp.breakpointSize = toSize;
				$(document).trigger("bootstrap:breakpoint-changed");
				// $(document).trigger('bootstrap:breakpoint-changed', [pp.breakpointSize, toSize]);
			}
		},
	},

	generateRandomId() {
		const randomMin = 0.5;
		const randomMax = 1;
		const constrainedRandom =
			Math.random() * (randomMax - randomMin) + randomMin;
		return Math.floor(constrainedRandom * (Math.pow(2, 31) + 1)); // A random number that fits into a four byte integer
	},

	detectCssRuleFor(selector, ruleName) {
		// pp.log("into detectCssRuleFor", selector, ruleName);
		if (
			pp.viewHelpers.cssRulesPerSelector[selector] !== undefined &&
			pp.viewHelpers.cssRulesPerSelector[selector][ruleName] !== undefined
		) {
			return pp.viewHelpers.cssRulesPerSelector[selector][ruleName]; // Cache
		}

		let rule;
		let i = 0;
		while (i < document.styleSheets.length && !rule) {
			let rulesOfSheet;
			try {
				// @ts-expect-error
				rulesOfSheet = document.styleSheets[i].cssRules;
			} catch (error) {
				// Catch exception due to cross-domain call
				// pp.log("err", error);
			}
			i++; // Increment here so that below `continue` will not use the same index again
			if (!rulesOfSheet) {
				continue;
			}

			let j = 0;
			while (j < rulesOfSheet.length && !rule) {
				const ruleSet = rulesOfSheet[j];
				j++; // Increment here so that below `continue` will not use the same index again
				if (
					// @ts-expect-error
					!ruleSet.selectorText ||
					// @ts-expect-error
					ruleSet.selectorText.indexOf(selector) == -1 ||
					// @ts-expect-error
					ruleSet.style[ruleName] === undefined
				) {
					continue;
				}

				// @ts-expect-error
				rule = ruleSet.style[ruleName];
			}
		}
		if (rule) {
			if (pp.viewHelpers.cssRulesPerSelector[selector] === undefined) {
				pp.viewHelpers.cssRulesPerSelector[selector] = {};
			}
			pp.viewHelpers.cssRulesPerSelector[selector][ruleName] = rule;
		}
		return rule; // Might be undefined
	},

	setInputFieldChangeListener: ($inputField, callback) => {
		// Used from pp.tokens and pp.users hashes
		let debounceInterval;
		$inputField.on("input paste", (event) => {
			clearTimeout(debounceInterval);
			debounceInterval = setTimeout(() => {
				debounceInterval = null;
				callback(event);
			}, 1000);
		});
	},

	replaceDropdownTriggerText: ($elem) => {
		const $dropdownToggle = $elem
			.closest(".dropdown")
			.find("[data-toggle='dropdown']");
		if ($dropdownToggle.parent().hasClass("j-is-static-title")) {
			return;
		}
		let $elemTopStrip = $elem.clone();
		$elemTopStrip.children(".Tag").remove();
		let text = $elemTopStrip.text().trim(1);

		// @ts-expect-error
		if ($elem.find(".visible-inline-xs").length && pp.breakpointSize == "xs") {
			text = $elem.find(".visible-inline-xs").text();
		}

		$dropdownToggle.find("span").first().text(text);
		$dropdownToggle.attr("title", $elem.attr("title"));
	},

	manageDropdownActiveState: ($elem) => {
		const $dropdownMenu = $elem.closest(".dropdown-menu");
		$dropdownMenu.find("a").parent().removeClass("active");
		// do this manually if we are not using the bootstrap toggle function (somehow only this is necessary)
		if (!$elem.attr("data-toggle")) {
			$elem.parent().addClass("active");
		}
		// hide dropdown menu, then set link name in dropdown header and mark active
		$dropdownMenu.find("li.dropdown").find("a").removeClass("active");
	},

	// This will get out of synch with the > xs NavTabs if the browser resizes,
	// but super edge case so not setting active on corresponding nav item in tabs / dropdown when one changes.
	replaceTriggerTextOnDropdown: ($dropdownContainer) => {
		$dropdownContainer.find(".dropdown-menu a").on("click", (event) => {
			const $elem = $(event.currentTarget);
			pp.viewHelpers.replaceDropdownTriggerText($elem);
			pp.viewHelpers.manageDropdownActiveState($elem);
		});
	},

	stringToSlug(str) {
		str = str.replace(/^\s+|\s+$/g, ""); // trim
		str = str.toLowerCase();

		// remove accents, swap ñ for n, etc
		const from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
		const to = "aaaaeeeeiiiioooouuuunc------";
		for (let i = 0, l = from.length; i < l; i++) {
			str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
		}

		str = str
			.replace(/[^a-z0-9 -]/g, "") // remove invalid chars
			.replace(/\s+/g, "-") // collapse whitespace and replace by -
			.replace(/-+/g, "-"); // collapse dashes

		return str;
	},

	scrollToTop() {
		if ("scrollRestoration" in history) {
			history.scrollRestoration = "manual";
		}
		window.scrollTo(0, 0);
	},

	scrollToElement($elem) {
		if (!$elem.length) {
			return;
		}
		let topOffset = $elem.offset().top - 8; // `8` = @base-grid-unit
		let $scrollTarget;
		let $workingScrollTarget = $elem.parent();
		pp.log("VIEW HELPERS scrollToElement", $elem, topOffset);
		// Find closest parent that
		// - does scroll (= have overflow) itself, and
		// - is shorter than the current window, or a modal (this is for the xs viewport where modals have 100% of the window height)
		// Otherwise select the `html` element if we arrived at the top, or climb up one parent
		while (!$scrollTarget) {
			// pp.log("-at:", $workingScrollTarget, $workingScrollTarget.hasClass('modal-content'));

			if ($workingScrollTarget.hasClass("modal-content")) {
				// For modals within which scrolling can happen: The modal might already exist and be scrolled down, in which case the `$elem`'s offset is not correct
				topOffset += $workingScrollTarget[0].scrollTop;
			}

			if (
				($workingScrollTarget[0].scrollHeight >
					$workingScrollTarget.outerHeight() &&
					$workingScrollTarget.outerHeight() < window.innerHeight) ||
				$workingScrollTarget.is(".modal.in")
			) {
				$scrollTarget = $workingScrollTarget;
			} else if ($workingScrollTarget[0].tagName == "BODY") {
				// Arrived at the top
				$scrollTarget = $("html");
			} else {
				$workingScrollTarget = $workingScrollTarget.parent();
			}
		}
		topOffset -= $scrollTarget.offset().top;

		// pp.log("-- scrollTarget, topOffset", $scrollTarget, topOffset);
		$scrollTarget.animate({ scrollTop: topOffset }, 150, "swing");
	},

	getRandomColor() {
		const letters = "0123456789ABCDEF";
		let color = "#";
		for (let i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * 16)];
		}
		return color;
	},

	preventPasteAction() {
		// prevent pasting any text into the message form
		if (
			pp.pastingPreventedInSelectors == null ||
			!pp.pastingPreventedInSelectors.length
		) {
			return;
		}
		$(document).on("paste", pp.pastingPreventedInSelectors, () => {
			pp.notifications.display("notice", I18n.t("global.pasting_prevented"));
			return false;
		});
	},

	initImageAutoUpload($targetForm) {
		pp.log("into initImageAutoUpload -- form", $targetForm);
		const $spinner = $targetForm.find(".j-fileupload-spinner");
		$spinner.addClass("hidden"); // In case it was visible before

		$targetForm.find("input[type='file']").one("change", (event) => {
			pp.log("initImageAutoUpload change -- event", event);
			if (event.currentTarget.value == "") {
				return;
			}
			$targetForm
				.closest(".modal")
				.find(".j-upload-button")
				.prop("disabled", false);
			$spinner.removeClass("hidden"); // Might or might not exist
			$targetForm.submit();
		});

		if (!bowser.safari) {
			return;
		}
		$targetForm.one("submit", (event) => {
			const csrfTokenName = $('meta[name="csrf-param"]').attr("content");
			const csrfToken = $('meta[name="csrf-token"]').attr("content");
			event.preventDefault();
			event.stopPropagation();
			$spinner.removeClass("hidden");
			const formData = new FormData(event.currentTarget);
			// @ts-expect-error
			formData.append(csrfTokenName, csrfToken);
			// pp.log("event, formData", event, formData);
			const xhr = new XMLHttpRequest();
			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					pp.log("response", xhr.response);
					eval(xhr.response);
				}
			};
			// @ts-expect-error
			xhr.open("PUT", $(event.currentTarget).attr("action"), true);
			xhr.send(formData);
		});
	},

	/**
	 * Wrapper function to invoke Jcrop on Images (Avatar and Publication)
	 */
	imageCropping: {
		minWidth: 100,
		imageStageCss: {
			margin: "0 auto",
			left: 0,
			right: 0,
		},

		invoke(aspectRatio) {
			pp.log("into imageCropping invoke -- aspectRatio", aspectRatio);
			this.aspectRatio = aspectRatio;
			this.$imageEl = $("#j-image-to-crop");
			this.$form = this.$imageEl.closest("form");

			this.$imageEl
				.closest(".modal")
				.find(".j-cancel-button")
				.one("click", () => {
					this.$form.find("input[name='asset[cancelled_crop]']").val("true");
					this.$form.submit();
				});

			if (this.$imageEl[0].complete) {
				this.initStage();
			} else {
				this.waitForImageToLoad(this.$imageEl[0])
					.then(() => {
						// Need to preseve the context, this call `this.initStage()` in this anonymous function
						this.initStage();
					})
					.catch(() => {
						pp.notifications.display("error", "Loading failed");
					});
			}
		},

		waitForImageToLoad(imageElement) {
			return new Promise((resolve, reject) => {
				imageElement.onload = resolve;
				imageElement.onerror = reject;
			});
		},

		initStage() {
			const scaleRatio =
				this.$imageEl[0].naturalHeight / this.$imageEl.height();
			// @ts-expect-error
			const cropStage = Jcrop.attach("j-image-to-crop", { multi: false });

			const minDimension = Math.min(...cropStage.getImageDimensions());
			if (
				// @ts-expect-error
				Math.min([
					this.$imageEl[0].naturalHeight,
					this.$imageEl[0].naturalWidth,
				]) < this.minWidth
			) {
				// The error modal will also close the modal in which the cropping form is being shown
				pp.notifications.display(
					"error",
					// @ts-expect-error
					`${I18n.t("activerecord.models.image.one")} ${I18n.t("errors.messages.greater_than_or_equal_to", { count: "100px * 100px" })}`,
				);
				return;
			}
			// @ts-expect-error
			const rect = Jcrop.Rect.create(
				16,
				16,
				minDimension * scaleRatio - 32,
				(minDimension * scaleRatio) / this.aspectRatio - 32,
			);

			cropStage.listen("crop.update", (widget) => {
				const coords = widget.pos;
				if (coords.w < this.minWidth) {
					coords.w = this.minWidth;
					coords.h = this.minWidth;
					cropStage.refresh();
				}
				$("#crop_x").val(Math.floor(coords.x * scaleRatio));
				$("#crop_y").val(Math.floor(coords.y * scaleRatio));
				$("#crop_w").val(Math.floor(coords.w * scaleRatio));
				$("#crop_h").val(Math.floor(coords.h * scaleRatio));
			});
			cropStage.newWidget(rect, {
				aspectRatio: this.aspectRatio,
				canRemove: false,
			});
			// Move the stage to the center (need to do a new query for some reason)
			$(".jcrop-image-stage").css(this.imageStageCss);
			this.$form.one("submit", () => {
				cropStage.destroy();
			});
			this.$form.one(
				"ajax:complete",
				pp.viewHelpers.keepSubmitButtonDisabledAfterAjaxFormSubmit,
			);
		},
	},

	enhanceModalFunctionality: {
		init() {
			// hide/destroy popovers in any modal when the modal is being closed
			$(document).on("hide.bs.modal", ".modal", (event) => {
				// @ts-expect-error
				$(event.currentTarget).find("[data-toggle='popover']").popover("hide");
			});
			$(document).on(
				"click",
				".modal a[data-slide='next'], .modal a[data-slide='prev']",
				pp.viewHelpers.enhanceModalFunctionality.toggleButtonVisibility,
			);
		},

		toggleButtonVisibility(event) {
			const $this = $(event.currentTarget);
			if (
				!$this.siblings("a[data-dismiss='modal']").length ||
				pp.viewHelpers.isBreakpointOfSize(">gridFloatBreakpoint")
			) {
				return;
			}
			const $modal = $this.closest("div.modal-content");
			const $carousel = $modal.find("div.carousel-inner");
			const $activeSlide = $carousel.find("div.item.active"); // NB this is the slide that will now be *hidden*
			let $targetedSlide =
				$activeSlide[$this.attr("data-slide") == "next" ? "next" : "prev"]();
			if (!$targetedSlide.length) {
				// In case the carousel wraps around, from the last slide to the first or vice versa
				if ($carousel.children().last() == $activeSlide) {
					$targetedSlide = $carousel.children().first();
				} else {
					$targetedSlide = $carousel.children().last();
				}
			}
			var indexOfTargetedSlide = $carousel
				.find("div.item")
				.index($targetedSlide);
			if (indexOfTargetedSlide + 1 == $carousel.find("div.item").length) {
				$modal.find("a[data-dismiss='modal']").removeClass("hidden");
				$modal.find("a[data-slide='next']").addClass("hidden");
			} else {
				$modal.find("a[data-dismiss='modal']").addClass("hidden");
				$modal.find("a[data-slide='next']").removeClass("hidden");
			}
		},
	},

	keepSubmitButtonDisabledAfterAjaxFormSubmit(event) {
		// pp.log("keepSubmitButtonDisabledAfterAjaxFormSubmit", event);
		const $disabledButton = $(this).find("button[type='submit']");
		event.stopPropagation(); // Prevent Rails from piping through the event and execute `enableFormElements`, which would re-enable the disabled button
		$disabledButton
			.removeAttr("data-confirm")
			// @ts-expect-error
			.attr("disabled", true)
			.html($disabledButton.data("ujs:enableWith"));
	},

	/**
	 * manage a small one-line text item form
	 */
	initSimpleInlineTextForm() {
		if (!$(".SimpleInlineTextForm-container").length) {
			return;
		}

		$(".SimpleInlineTextForm__edit-button").on("click", (event) => {
			$(".SimpleInlineTextForm__current-content").hide();
			$(event.currentTarget).hide();
			$(event.currentTarget).siblings("form").removeClass("hidden");
			// remove value, then reset it for cursor to move to the end of the input box
			$(".SimpleInlineTextForm__input")
				.trigger("focus")
				.val("")
				.val($(".SimpleInlineTextForm__current-content").text());
		});
		$(".SimpleInlineTextForm__current-content").on("click", () => {
			$(".SimpleInlineTextForm__edit-button").trigger("click");
		});

		$(".SimpleInlineTextForm__input").on("blur", ({ currentTarget }) => {
			// Reset the form and then hide it unless the user clicked the submit button
			const hideFormTimeout = setTimeout(() => {
				// @ts-expect-error
				$($(".SimpleInlineTextForm__input")[0].form).off("submit");
				$(currentTarget).parent().addClass("hidden").siblings().show();
				pp.pageChangeConfirm.removeListeners($(currentTarget)); // have to remove the page change confirm listener manually
			}, 150);
			// @ts-expect-error
			$($(".SimpleInlineTextForm__input")[0].form).one("submit", () => {
				clearTimeout(hideFormTimeout);
				$(document).one("ajaxComplete", ({ currentTarget }, request) => {
					$(currentTarget).parent().addClass("hidden").siblings().show();
				});
			});
		});
	},

	initDropdownTabPaneSwitch() {
		$("a.j-dropdown-link").on("click", function () {
			const $elem = $(this);

			pp.viewHelpers.replaceDropdownTriggerText($elem);
			pp.viewHelpers.manageDropdownActiveState($elem);
			let activeTextBodySelector;
			if ($elem.attr("data-article-id") !== undefined) {
				activeTextBodySelector = `[data-article-id='${$elem.attr("data-article-id")}']`;
			} else if ($elem.attr("data-topic-id") !== undefined) {
				activeTextBodySelector = `[data-topic-id='${$elem.attr("data-topic-id")}']`;
			} else {
				return;
			}
			$(".j-text-body").addClass("hidden");
			$(`.j-text-body${activeTextBodySelector}`).removeClass("hidden");
		});
	},

	dependentInputs: {
		dependableAttributesToStateMethods: {
			enabled_contingent_on: {
				methodNameToCall: "setElemDisableState",
				inputAttrSelector: "name*=",
			},
			disabled_contingent_on: {
				methodNameToCall: "setElemEnableState",
				inputAttrSelector: "name*=",
			},
			visible_contingent_on: {
				methodNameToCall: "setElemVisibleState",
				inputAttrSelector: "name*=",
			},
			hidden_contingent_on: {
				methodNameToCall: "setElemHiddenState",
				inputAttrSelector: "name*=",
			},
			toggle_contingent_on: {
				methodNameToCall: "setElemCheckedState",
				inputAttrSelector: "id=",
			},
		},

		init($targetContainer = $("body")) {
			Object.entries(
				pp.viewHelpers.dependentInputs.dependableAttributesToStateMethods,
			).forEach(([dependableAttr, options]) => {
				// pp.log("DEPENDENT INPUTS looking at dependable attr", dependableAttr);
				$targetContainer.find(`[${dependableAttr}]`).each((index, elem) => {
					// @ts-expect-error
					const $form = $(elem.form || $(elem).closest("form"));
					const $dependableInputs = $form.find(
						`input[${options.inputAttrSelector}'${$(elem).attr(dependableAttr)}'], select[${options.inputAttrSelector}'${$(elem).attr(dependableAttr)}']`,
					);
					// pp.log("- el", elem, $form, $dependableInputs);
					if (!$dependableInputs.length) {
						// pp.log("-- Skipping, no dependable fields found")
						return; // `continue` for jQuery
					}
					// Only add listener for each element once
					let listenerAlreadyPresent = false;
					$dependableInputs.each((index, inputEl) => {
						// pp.log("-- input", index, inputEl);
						const dataDependentElems = $(inputEl).data("dependentElems") || [];
						// pp.log("-- els before", dataDependentElems);
						if (dataDependentElems.includes(elem)) {
							listenerAlreadyPresent = true;
						} else {
							dataDependentElems.push(elem);
							$(inputEl).data("dependentElems", dataDependentElems);
						}
						// pp.log("-- els after", dataDependentElems);
					});
					if (listenerAlreadyPresent) {
						// pp.log("skip");
						return;
					}
					// Set up listeners to update the state (currently: disabled or visible) of the dependent inputs if their dependable input changes
					$dependableInputs.on("change", () => {
						pp.viewHelpers.dependentInputs.handleDepenableFieldChange(
							dependableAttr,
							elem,
						);
					});
					// Set state of depentent input once now, assume that disabled dependable inputs should not affect their dependent fields
					if (
						$dependableInputs.get().find(
							// @ts-expect-error
							(input) => !input.disabled || input.dataset.alwaysTriggerChange,
						)
					) {
						pp.viewHelpers.dependentInputs.handleDepenableFieldChange(
							dependableAttr,
							elem,
						);
					}
				});
			});
		},

		handleDepenableFieldChange(dependableAttr, elem) {
			const module = pp.viewHelpers.dependentInputs;
			const elemState = module.determineElemState(dependableAttr, elem);
			const methodNameToCall =
				module.dependableAttributesToStateMethods[dependableAttr]
					.methodNameToCall;
			// pp.log("handleDepenableFieldChange for", elem, dependableAttr, elemState, methodNameToCall);
			module[methodNameToCall]($(elem), elemState);
		},

		determineElemState(dependableAttr, elem) {
			const $elem = $(elem);
			const $form = $(elem.form || $elem.closest("form"));
			const inputAttrSelector =
				pp.viewHelpers.dependentInputs.dependableAttributesToStateMethods[
					dependableAttr
				].inputAttrSelector;
			// NB assume that the input fields will be checkboxes, where each checkbox has the `name` attribute
			let dependableElementsQuery = `input[${inputAttrSelector}'${$elem.attr(dependableAttr)}']`;
			// pp.log("gut dependableElementsQuery:", dependableElementsQuery);
			// NB if that's not the case, assume that the *one* element with the `name` attribute is a `select`, which
			// has multiple children that are `option` elements
			if (!$form.find(dependableElementsQuery).length) {
				// pp.log("- setting `select` rather than `input`");
				dependableElementsQuery = `select[${inputAttrSelector}'${$elem.attr(dependableAttr)}'] option`;
			}
			const dependatableValues = $elem.attr("enabled_for_values");
			let enableElement = false;

			if (dependatableValues !== undefined) {
				// NB make sure that at least one input element that is declared as "dependable" even exists on the page
				const presentDepenableElemValues = _.filter(
					dependatableValues.split(" "),
					(value) => {
						// pp.log("- dependable input query", $form.find(dependableElementsQuery + `[value='${value}']`));
						return (
							$form.find(dependableElementsQuery + `[value='${value}']`)
								.length != 0
						);
					},
				);
				if (presentDepenableElemValues.length == 0) {
					console.error(
						`Did not find any dependable elements for an input element that should depend on: ${dependatableValues}`,
						$elem,
					);
					enableElement = true; // Never disable element if the depenable input field does not exist
				} else {
					enableElement =
						_.find(presentDepenableElemValues, (value) => {
							// NB this either checks if the dependable element with the requested value exists and is checked, *or*
							// it checkes if the requested value is '0' (i.e. "disabled") *and* there is no checked dependable element at all.
							return (
								$form.find(
									dependableElementsQuery + `[value='${value}']:checked`,
								).length != 0 ||
								(value == "0" &&
									$form.find(dependableElementsQuery + ":checked").length == 0)
							);
						}) !== undefined;
				}
			} else {
				// pp.log("single elem:", $form.find(dependableElementsQuery + "[type='checkbox']"), $form.find(dependableElementsQuery).prop('checked'));
				enableElement =
					$form.find(dependableElementsQuery + "[type='checkbox']").length ==
						1 &&
					$form
						.find(dependableElementsQuery + "[type='checkbox']")
						.prop("checked") == true;
			}
			return enableElement;
		},

		setElemDisableState($elem, enableElement) {
			// NB allow non-checkbox inputs to still have their input values manipulated
			// (e.g. for `commenth_depth in articles/backend/_general_fields)
			const propToSet =
				["checkbox", "radio"].includes($elem.attr("type")) ||
				$elem[0].tagName == "SELECT"
					? "disabled"
					: "readonly";
			$elem.prop(propToSet, !enableElement);
			$elem
				.closest(".form-group")
				[enableElement ? "removeClass" : "addClass"]("disabled");
		},

		// Inverse of above
		setElemEnableState($elem, enableElement) {
			pp.viewHelpers.dependentInputs.setElemDisableState($elem, !enableElement);
		},

		setElemVisibleState($elem, enableElement) {
			// pp.log("setElemVisibleState", $elem, enableElement);
			const $target = $elem.closest(".form-group").length
				? $elem.closest(".form-group")
				: $elem;
			$target[enableElement ? "show" : "hide"]();
			pp.backend.formHelpers.initSelect2For($target.find("select:visible"));
		},

		setElemHiddenState($elem, disableElement) {
			// pp.log("setElemHiddenState", $elem, disableElement);
			const $target = $elem.closest(".form-group").length
				? $elem.closest(".form-group")
				: $elem;
			$target[disableElement ? "hide" : "show"]();
			pp.backend.formHelpers.initSelect2For($target.find("select:visible"));
		},

		setElemCheckedState($elem, enableElement) {
			// pp.log("setElemCheckedState", $elem, enableElement);
			const $target = $elem.closest(".form-group").length
				? $elem.closest(".form-group")
				: $elem;
			$target.prop("checked", enableElement);
			$target.trigger("change"); // Cascade further
			pp.backend.formHelpers.initSelect2For($target.find("select:visible"));
		},
	},

	setModuleAndTableRowHeight(moduleSelector) {
		// pp.log("into setModuleAndTableRowHeight", moduleSelector);
		const $module = $(
			`${moduleSelector}[data-max-height-table-rows], ${moduleSelector}[data-max-height-px], ${moduleSelector}[data-max-height-panels]`,
		);
		const $moduleContent = $module.find(".Module__content");
		const maxHeightPx = $module.data("max-height-px");
		const maxHeightTableRows = $module.data("max-height-table-rows");
		const maxHeightPanels = $module.data("max-height-panels");
		const $toggleButton = $module.find(".j-show-toggle");

		let reduceModuleHeight;
		let restoreModuleHeight;

		if (maxHeightPx) {
			reduceModuleHeight = ($moduleContent, maxHeightPx) => {
				$moduleContent.height(`${maxHeightPx}px`);
			};
			restoreModuleHeight = ($moduleContent) => {
				$moduleContent.height("auto");
			};
		} else if (maxHeightTableRows) {
			if (
				$moduleContent.find("table tbody").children().length <=
				maxHeightTableRows
			) {
				$toggleButton.hide();
				return;
			}

			reduceModuleHeight = ($moduleContent, maxHeightTableRows) => {
				$moduleContent
					.find(`table tbody tr:gt(${maxHeightTableRows - 1})`)
					.hide();
			};
			restoreModuleHeight = ($moduleContent) => {
				$moduleContent
					.find(`table tbody tr:gt(${maxHeightTableRows - 1})`)
					.show();
			};
		} else if (maxHeightPanels) {
			if ($moduleContent.find(".panel-default").length <= maxHeightPanels) {
				$toggleButton.hide();
				return;
			}

			reduceModuleHeight = ($moduleContent, maxHeightPanels) => {
				$moduleContent.find(`.panel-default:gt(${maxHeightPanels - 1})`).hide();
			};
			restoreModuleHeight = ($moduleContent) => {
				$moduleContent.find(`.panel-default:gt(${maxHeightPanels - 1})`).show();
			};
		}

		$toggleButton.on("click", () => {
			if (!$module.data("hasReducedHeight")) {
				reduceModuleHeight(
					$moduleContent,
					maxHeightPx || maxHeightTableRows || maxHeightPanels,
				);
				$toggleButton.find(".j-show-more").removeClass("hidden");
				$toggleButton.find(".j-show-fewer").addClass("hidden");
				$module.data("hasReducedHeight", true);
			} else {
				restoreModuleHeight($moduleContent);
				$toggleButton.find(".j-show-more").addClass("hidden");
				$toggleButton.find(".j-show-fewer").removeClass("hidden");
				$module.data("hasReducedHeight", false);
			}
		});
		$toggleButton.trigger("click"); // Trigger once now
	},

	autoCloseModal: function (modalSelector, afterSeconds) {
		let autoCloseTime = afterSeconds;
		const $modal = $(modalSelector);
		const autoCloseInterval = setInterval(() => {
			autoCloseTime -= 1;
			// pp.log("autoCloseTime", autoCloseTime);
			let percentUntilClose = (autoCloseTime / afterSeconds) * 100;
			$modal.find(".closing-inner").css({ width: percentUntilClose + "%" });
			if (autoCloseTime > 0) {
				return;
			}
			$modal.find(".j-close-modal-fullscreen").trigger("click");
			clearInterval(autoCloseInterval);
		}, 1000);

		$modal.find(".j-close-modal-fullscreen").on("click", () => {
			if (autoCloseInterval) {
				window.clearInterval(autoCloseInterval);
			}
		});
	},

	copyToClipboardListener(
		linkSeletor,
		contentSelector,
		showSuccessAsNotice = false,
	) {
		pp.log(
			"VIEW HELPERS copyToClipboardListener",
			linkSeletor,
			contentSelector,
		);
		$(linkSeletor).on("click", function () {
			const contentToCopy = $(contentSelector)[0];
			const range = document.createRange();
			range.selectNode(contentToCopy);
			// @ts-expect-error
			window.getSelection().addRange(range);

			document.execCommand("copy");

			// @ts-expect-error
			window.getSelection().removeAllRanges();
			if (showSuccessAsNotice) {
				pp.notifications.display(
					"notice",
					I18n.t("global.copied_to_clipboard"),
				);
			} else {
				$(linkSeletor).html(`✔ ${I18n.t("global.copied_to_clipboard")}`);
			}
		});
	},

	// These (mostly) mirror the validators set in the resp. models and are used for clientSideValidations
	// Can't declare those as a simple hash because `I18n` is not present yet at loading time
	clientSideValidatorsFor: (model, attribute) => {
		switch (model) {
			case "actor":
				switch (attribute) {
					case "cloned_from_id":
						return {
							presence: [{ message: I18n.t("errors.messages.required") }],
						};
				}
				break;

			case "game":
				switch (attribute) {
					case "name":
						return {
							length: [
								{
									messages: {
										minimum: I18n.t("errors.messages.too_short", { count: 5 }),
										maximum: I18n.t("errors.messages.too_long", { count: 255 }),
									},
									minimum: 5,
									maximum: 255,
								},
							],
						};
				}
				break;

			case "game_token":
				switch (attribute) {
					case "tokens_count":
						return {
							presence: [{ message: I18n.t("errors.messages.required") }],
							numericality: [
								{
									messages: {
										greater_than_or_equal_to: I18n.t(
											"errors.messages.greater_than_or_equal_to",
											{ count: 1 },
										),
									},
									greater_than_or_equal_to: 1,
								},
								{
									messages: {
										less_than_or_equal_to: I18n.t(
											"errors.messages.less_than_or_equal_to",
											{ count: 20 },
										),
									},
									less_than_or_equal_to: 20,
								},
							],
						};
				}
				break;

			case "modifier":
				switch (attribute) {
					case "user_input":
						return {
							presence: [{ message: I18n.t("errors.messages.required") }],
							numericality: [
								{
									messages: {
										greater_than_or_equal_to: I18n.t(
											"errors.messages.greater_than_or_equal_to",
											{ count: 0 },
										),
									},
									greater_than_or_equal_to: 0,
								},
							],
						};
				}
				break;

			case "new_co_mod": // Fake model name to allow a special case with `allow_blank`
				switch (attribute) {
					case "name":
						return {
							length: [
								{
									messages: {
										minimum: I18n.t("errors.messages.too_short", { count: 3 }),
										maximum: I18n.t("errors.messages.too_long", { count: 45 }),
									},
									allow_blank: true,
									minimum: 3,
									maximum: 45,
								},
							],
						};
				}
				break;

			case "user":
				switch (attribute) {
					case "name":
						return {
							length: [
								{
									messages: {
										minimum: I18n.t("errors.messages.too_short", { count: 3 }),
										maximum: I18n.t("errors.messages.too_long", { count: 45 }),
									},
									minimum: 3,
									maximum: 45,
								},
							],
						};
				}
				break;
		}
	},
};
